/**
 * Keeps the cart drawer's "Envío Premium Gratis" banner and countdown timer in sync.
 *
 * Loaded once via <script src> from snippets/cart-drawer.liquid, outside the parts of
 * the drawer that Shopify swaps with innerHTML on cart updates (AJAX add-to-cart,
 * quantity changes). Script tags injected via innerHTML never execute, so the render
 * logic lives here instead of inline in the swapped markup, and re-syncs itself
 * through the theme's existing cart-update pub/sub event (assets/cart.js already
 * publishes it after every quantity/add/remove) plus one narrow, attribute-only
 * MutationObserver for the drawer's open/close state.
 */
(function () {
  if (window.__cartDrawerExtrasInit) return;
  window.__cartDrawerExtrasInit = true;

  function renderShippingProgress(itemCount) {
    document.querySelectorAll('.cart-shipping-progress').forEach(function (el) {
      var threshold = parseInt(el.getAttribute('data-threshold'), 10) || 2;
      var unlocked = itemCount >= threshold;
      el.classList.toggle('is-unlocked', unlocked);
      el.classList.toggle('is-locked', !unlocked);

      var inner = el.querySelector('.cart-shipping-progress__inner');
      var textWrap = el.querySelector('.cart-shipping-progress__text');
      var headline = el.querySelector('.cart-shipping-progress__headline');
      var subline = el.querySelector('.cart-shipping-progress__subline');
      var dots = el.querySelector('.cart-shipping-progress__dots');

      if (unlocked) {
        if (headline) headline.textContent = 'Envío Premium Gratis desbloqueado';
        if (subline) subline.remove();
        if (dots) dots.remove();
      } else {
        if (headline) headline.textContent = 'Envío Premium Gratis';
        var remaining = threshold - itemCount;
        var sublineText =
          'Añade ' + remaining + (remaining === 1 ? ' producto más' : ' productos más') + ' para desbloquearlo';

        if (!subline && textWrap) {
          subline = document.createElement('span');
          subline.className = 'cart-shipping-progress__subline';
          textWrap.appendChild(subline);
        }
        if (subline) subline.textContent = sublineText;

        var dotsHtml = '';
        for (var i = 1; i <= threshold; i++) {
          dotsHtml += '<span class="' + (i <= itemCount ? 'is-filled' : '') + '"></span>';
        }
        if (!dots && inner) {
          dots = document.createElement('span');
          dots.className = 'cart-shipping-progress__dots';
          inner.appendChild(dots);
        }
        if (dots) dots.innerHTML = dotsHtml;
      }
    });
  }

  function fetchCartAndRenderShipping() {
    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        renderShippingProgress(cart.item_count);
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.cartData && typeof event.cartData.item_count === 'number') {
        renderShippingProgress(event.cartData.item_count);
      } else {
        fetchCartAndRenderShipping();
      }
    });
  }

  // ---- Urgency timer: starts at exactly 10:00 the first time the drawer is opened
  // in this browser tab (not from page load). After that it's allowed to count down
  // to 3 minutes, and only then jumps back up — to a random point between 6:00 and
  // 8:55 (never a round number of minutes, so it never reads e.g. "8:00" again) — so
  // it keeps ticking down for a while each time instead of resetting the moment it
  // dips below 10, while still never being able to reach zero.
  var TIMER_STORAGE_KEY = 'cartUrgencyExpiresAt';
  var TIMER_INITIAL_SECONDS = 600; // first open this session: exactly 10:00
  var TIMER_MIN_SECONDS = 180; // floor before it jumps back up: 3:00
  var timerInterval = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // Random reset point: strictly between 6:00 and 8:55 (never below or above),
  // and never lands exactly on a round minute.
  function randomResetSeconds() {
    var minTotal = 361; // 6:01
    var maxTotal = 535; // 8:55
    var total = minTotal + Math.floor(Math.random() * (maxTotal - minTotal + 1));
    if (total % 60 === 0) total -= 1;
    return total;
  }

  // Reads the stored expiry. On the very first check this session there's nothing
  // stored, so it starts at exactly 10:00. From then on, once it would show 3
  // minutes or less, it's pushed back out to a random point above 6 minutes.
  function getTimerExpiry() {
    var stored;
    try {
      stored = sessionStorage.getItem(TIMER_STORAGE_KEY);
    } catch (e) {
      stored = null;
    }
    var expiry = stored ? parseInt(stored, 10) : NaN;
    var remainingSeconds = expiry ? (expiry - Date.now()) / 1000 : -1;

    if (!expiry || isNaN(expiry)) {
      expiry = Date.now() + TIMER_INITIAL_SECONDS * 1000;
      try {
        sessionStorage.setItem(TIMER_STORAGE_KEY, String(expiry));
      } catch (e) {}
    } else if (remainingSeconds <= TIMER_MIN_SECONDS) {
      expiry = Date.now() + randomResetSeconds() * 1000;
      try {
        sessionStorage.setItem(TIMER_STORAGE_KEY, String(expiry));
      } catch (e) {}
    }
    return expiry;
  }

  function tickTimer() {
    var el = document.getElementById('CartUrgencyTimerValue');
    if (!el) return;
    var expiry = getTimerExpiry();
    var remaining = Math.max(0, Math.round((expiry - Date.now()) / 1000));
    el.textContent = pad(Math.floor(remaining / 60)) + ':' + pad(remaining % 60);
  }

  function startUrgencyTimerIfOpen() {
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (!cartDrawerEl || !cartDrawerEl.classList.contains('active')) return;

    tickTimer();
    if (!timerInterval) {
      timerInterval = setInterval(tickTimer, 1000);
    }
  }

  var cartDrawerRoot = document.querySelector('cart-drawer');
  if (cartDrawerRoot) {
    if (cartDrawerRoot.classList.contains('active')) startUrgencyTimerIfOpen();
    // Narrow on purpose: only the cart-drawer element's own "class" attribute,
    // no subtree. A subtree/childList observer here previously fed back into
    // itself — renderShippingProgress() adds/removes DOM nodes, which re-fired
    // the observer, which re-rendered, forever — and froze the tab.
    new MutationObserver(function () {
      startUrgencyTimerIfOpen();
    }).observe(cartDrawerRoot, { attributes: true, attributeFilter: ['class'] });
  }

  // Re-sync whenever the theme reports a cart change (quantity update, add to cart,
  // remove) via its existing pub/sub event — this is what actually keeps the
  // shipping banner correct after Dawn swaps part of the drawer's markup, without
  // watching the whole DOM for mutations.
  fetchCartAndRenderShipping();

  // ---- Minus-to-zero removes the line, like the trash button.
  //
  // Dawn's QuantityInput (assets/global.js) lets the "-" button step the native
  // <input min="0"> down to 0, but assets/cart.js's CartItems.validateQuantity()
  // then compares that 0 against data-min (the variant's quantity_rule.min, which
  // defaults to 1) and rejects it with a "mínimo de X" validation error instead of
  // ever calling updateQuantity() — so the line never gets removed, it just resets
  // back to 1. Intercepted here in the capture phase (runs before QuantityInput's
  // own click handler, which is bound directly on the button) so we can call the
  // same updateQuantity(line, 0, event) that CartRemoveButton uses, and stop the
  // event before Dawn's normal step-down/validate flow ever runs.
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('.cart-drawer .quantity__button[name="minus"]');
      if (!button) return;

      var quantityInputEl = button.closest('quantity-input');
      var input = quantityInputEl && quantityInputEl.querySelector('input');
      if (!input) return;

      var current = parseInt(input.value, 10);
      if (isNaN(current) || current > 1) return;

      var cartItems = button.closest('cart-drawer-items');
      var index = input.dataset.index;
      if (!cartItems || !index) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      cartItems.updateQuantity(index, 0, event);
    },
    true
  );
})();
